import { render, staticRenderFns } from "./chart5.vue?vue&type=template&id=57081ffb&scoped=true&"
import script from "./chart5.vue?vue&type=script&lang=js&"
export * from "./chart5.vue?vue&type=script&lang=js&"
import style0 from "./chart5.vue?vue&type=style&index=0&id=57081ffb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57081ffb",
  null
  
)

export default component.exports